const lessonConfig = {
  subTables: {
    sub_topic_items: {
      label: {
        plural: "Subtopic Types",
        singular: "Subtopic Type",
      },
      listMetadata: [
        {
          name: "sort_order",
          label: "Sort Order",
          parser: (data) => data.sort_order,
        },
        {
          name: "item_type",
          label: "Subtopic Type",
          parser: (data) => {
            switch (data.item_type) {
              case "ContentSubtopic":
                return "Content Subtopic";
              case "Profile":
                return "Profile";
              case "Category":
                return "Category";
              case "FeaturedContent":
                return "Featured Content";
              case "CustomUrl":
                return "Custom URL";
              default:
                return data.item_type;
            }
          },
        },
        {
          name: "custom_text",
          label: "Custom Text",
          parser: (data) => {
            if (data.item_type === "FeaturedContent") {
              return data.custom_text;
            }
            return "N/A";
          },
        },
        {
          name: "name",
          label: "Name",
          parser: (data) => {
            if (data.item_type === "FeaturedContent") {
              const maxLength = 30;
              if (data.name?.length > maxLength) {
                return data.name.slice(0, maxLength) + "...";
              }
              return data.name;
            }
            return data.name;
          },
        },
      ],
      detailsMetadata: [
        {
          name: "subtopic_type",
          label: ""
        }
      ],
    },
  },
};

export default lessonConfig;


